<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import Icon from './Icon.svelte';

  export let quantity = 0;
  export let min = 0;
  export let max = Infinity;

  const dispatch = createEventDispatcher();

  const increment = () => {
    quantity += 1;
    notifyQuantityChange();
  };

  const decrement = () => {
    quantity -= 1;
    notifyQuantityChange();
  };

  function notifyQuantityChange() {
    dispatch('quantityChange', { quantity: quantity });
  }

  export function reset() {
    quantity = 0;
  }
</script>

<div class="quantity-selector">
  <button class="btn-increment" on:click={increment} disabled={quantity == max}
    ><Icon icon="plus"></Icon></button
  >
  <span>{quantity}</span>
  <button class="btn-decrement" on:click={decrement} disabled={quantity == min}
    ><Icon icon="minus"></Icon></button
  >
</div>

<style>
  .quantity-selector {
    background-color: var(--white);
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid var(--white);
    border-radius: 5px;
  }

  button {
    color: var(--grey-15);
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 12px;
    margin: 0;
    border: none;
    background-color: transparent;
  }

  .btn-increment {
    padding-top: 16px;
  }

  .btn-decrement {
    padding-bottom: 16px;
  }

  button:disabled {
    color: var(--grey-60);
  }

  button:focus {
    outline: none;
  }

  span {
    color: var(--grey-15);
    font-size: 18px;
    font-weight: 500;
    padding-top: 12px;
    padding-bottom: 12px;
  }
</style>
